import httpRequest from '../request/indexBase'
import { local } from '@/utils/storage'
import { menuList, newMenuList } from '../mockData/menuData'
import { getVersionType } from '@/utils/checkStatus'

// 从字典获取值
export function getCodeTreeByCode(params) {
  return httpRequest.get({
    url: `/dictionary-item/code/tree`,
    params
  })
}

// 文件上传
export function uploadFile(data, code) {
  return httpRequest.post({
    url: `/repository/files-record/fileUpload`,
    data,
    specialToken: code ? JSON.parse(localStorage.getItem('editKoken')) : local.get('TOKEN')
  })
}

// 文件上传
export function uploadFileNoAuth(data) {
  return httpRequest.post({
    url: `/repository/files-record/NoAuth/fileUpload`,
    data
  })
}
// 获取记录未读条数
export function getWfRecordUnreadCount() {
  return httpRequest.get({
    url: `/workflow/workflow-execute-record/getWfRecordUnreadCount`
  })
}
// 获取对应权限的菜单
export function getMenuList(params) {
  // SoloSmart2 菜单先使用本地固定数据，后续接 API 时改为 false。
  const useMock = true
  if (useMock) {
    return new Promise((resolve) => {
      resolve({
        data: getVersionType() === 'pro' ? newMenuList : menuList
      })
    })
  } else {
    return httpRequest.get({
      url: `/permission/resource/getMenuListRoleTree`,
      params
    })
  }
}
// 根据工作流id获取记录未读条数
export function getWfRecordUnreadCountByWfId(params) {
  return httpRequest.get({
    url: `/workflow/workflow-execute-record/getWfRecordUnreadCountByWfId`,
    params
  })
}

// 查询用户团队角色
export function getUserTeamRole(params) {
  return httpRequest.get({
    url: `/permission/team-user/getUserTeamRole`,
    params
  })
}

// 根据id查询对应数智员工
export function userAppPermission(data) {
  return httpRequest.post({
    url: `/workflow/chat-title/userAppPermission`,
    data
  })
}
